export const TXP_OPTIONS_V2_FEATURE = 'cal-txp-optionsV2';
export const GRIFFIN_REQUEST_BASEURL = 'txp/api/v1.0/me/{0}';
export const USER_SETTINGS = 'UserSettings';
